import { StateDescription } from './StateDescription'

export function ReviewingCardDescription() {
  return (
    <StateDescription title="What triggers it">
      The card shows “Reviewing submitted info” when we’ve put our own estimate on the card, and the carrier
      has flagged the application for manual review. On main, the only code that sets that flag is in Corgi’s
      integrations, when Corgi’s API reports a quote has gone to manual review. No other carrier can produce
      this status.
    </StateDescription>
  )
}
